import { Component, OnInit, Input } from '@angular/core';
import { NodoEntity, FormatoAsistencialEntity, FiltrosFormatoAsistencialEntity, ServicioFormatoAsistencialService, OdontogramaValueEntity } from 'src/app/services/servicio-formato-asistencial.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-odontograma',
  templateUrl: './odontograma.component.html',
  styleUrls: ['./odontograma.component.css']
})
export class OdontogramaComponent implements OnInit {

  @Input() filtros: FiltrosFormatoAsistencialEntity;
  @Input() data: FormatoAsistencialEntity;
  @Input() nodo: NodoEntity;
  
  titulo: string;
  img: string;
  info: OdontogramaValueEntity;
  registroPlaca: boolean;

  constructor(private servicioFormato: ServicioFormatoAsistencialService) { }

  ngOnInit() {
    if (this.nodo && this.filtros) {
      this.onProcess();
    } else {
      this.titulo = '';
    }
  }

  onProcess() {
    this.titulo = this.nodo.titulo;
    this.registroPlaca = this.nodo.valor.includes('rgstr_plca');
    this.getImagen();
    this.getInformacionOdontograma();
  }

  async getImagen() {
    const request = await this.servicioFormato.getImagenNodo(this.filtros.codigoBaseDatos, this.filtros.entidadEmpresarial.unco, this.filtros.tta, this.nodo.id);
    request.subscribe((data: any) => {
      this.img = data.source;
    }, (err: HttpErrorResponse) => {
      this.img = null;
      console.error('Odontograma ', err);
    })
  }

  async getInformacionOdontograma() {
    const request = await this.servicioFormato.getOdontograma(this.filtros.codigoBaseDatos, this.filtros.tta, this.nodo.id);
    request.subscribe((data: OdontogramaValueEntity) => {
      this.info = data;
    }, (err: HttpErrorResponse) => {
      this.info = null;
      console.error('Odontograma.getInformacion()', err);
    })
  }

  async getInformacionRegistroPlaca() {

  }

}
